export default "__VITE_ASSET__BePXvGiW__"